import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  actionsContainer: {
    display: 'inline-flex',
    border: '1px #ced4da solid',
    borderRadius: '3px',
    height: '30px',
    padding: '1px',
    alignItems: 'center',
  },
  action: {
    padding: '3px',
  },
  actionIcon: {
    height: '16px',
  },
  actionWithBorder: {
    borderLeft: '1px solid #ced4da',
    padding: '3px',
  },
  actionLabel: {
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'space-around',
  },
  actionLabelSpan: {
    paddingLeft: '3px',
  },
  importantHover: {
    '&.MuiListItemButton-root:hover': {
      backgroundColor: '#FEECEB',
    },
  },
  highHover: {
    '&.MuiListItemButton-root:hover': {
      backgroundColor: '#BC0000',
      color: 'white',
      '& svg': {
        color: 'white !important',
      },
    },
    '&.MuiListItemButton-root svg:hover': {
      color: 'white !important',
    },
  },
}));
